import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import Map from '../images/graph-image.png'
import Header from '../components/Header'

const Contract = () => {


    return (
        <>
            <Header />
            <section className="bg-secondary-100 ">
                <div className="h-fit py-10  px-4 md:px-6 lg:px-40">

                    <div className="lg:my-20 pt-20" >

                        <div className="grid grid-cols-12" >
                            <div className="col-span-12 md:col-start-1 md:col-span-5 text-white px-5 lg:px-10">



                                <h2 className="font-psemibold text-center mb-5 text-2xl wow animate__animated animate__zoomIn">
                                    <span className="text-secondary"> MARK MAN</span> CONTRACT ADDRESS</h2>

                                    <ul className="text-sm font-pregular text-md my-5">
                                   <li className="mb-5">Registration Contract: <a href="https://bscscan.com/address/0x330bF7295957A8F22e6E2FFe1b56fBB5c387aEEc#code" className="text-primary" target="_blank">View Address <i className="fa fa-arrow-right"></i></a></li>
                                   
                                   <div className="hor-line w-100 my-10"></div>
                                   
                                   <li className="mb-5">Matrix Contract: <a href="https://bscscan.com/address/0x0C406a2EDA55601d88Bd96914872db6D2972FB82#code" className="text-primary">View Address<i className="fa fa-arrow-right"></i></a></li>
                                   
                                   
                                   <div className="hor-line w-100 my-10"></div>
                                   <li className="mb-5">Lottery Contract: <a href="#" className="text-primary">Coming Soon! <i className="fa fa-arrow-right"></i></a></li>
                                   
                                   
                                   <div className="hor-line w-100 my-10"></div>
                                   <li className="mb-5">Royalty Contract: <a href="#" className="text-primary">Coming Soon! <i className="fa fa-arrow-right"></i></a></li>
                                   
                                   </ul>
                                {/* 
                                    <div className="hor-line w-100 my-10"></div>

                                <h2 className="font-pmedium text-center mb-5 text-xl wow animate__animated animate__zoomIn text">Confirm User ID</h2>

                                    <input className="w-full wow animate__animated animate__zoomIn p-3 mb-4 rounded-lg w-80" placeholder="Enter User ID" />

                                <button className="wow animate__animated animate__zoomIn mb-5 rounded-xl bg-primary text-secondary-100 shadow px-10 py-3 text-sm font-pmedium wow animate__animated animate__fadeInUp" data--wow-delay="1s">View User</button>
 */}
                               
                            </div>

                            <div className="col-span-12 md:col-span-6 text-white md:px-10 md:px-0">
                                <img src={Map} className="w-full float mt-10 md:mt-0 " />
                            </div>
                        </div>
                    </div>

                </div>
            </section>


        </>

    )
}

export default Contract;